<template>
    <div id="ProfileSettings">
        <header>
            <VuiButton type="text" class="btn" @click.native="$router.go(-1)">返回</VuiButton>
            <p class="title">账户</p>
            <VuiButton type="text" class="btn" style="visibility: hidden;">完成</VuiButton>
        </header>
        <main>
            <section @click="handleClick('userName')">
                <label>姓名</label>
                <input type="text" v-model="userinfo.name" readonly>
            </section>
            <section @click="handleClick('location')">
                <label>城市</label>
                <input type="text" v-model="userinfo.location" readonly>
            </section>
            <section @click="handleClick('officeName')">
                <label>工作单位</label>
                <input type="text" v-model="userinfo.officeName" readonly>
            </section>
            <section @click="handleClick('phone')">
                <label>手机号码</label>
                <input type="text" v-model="userinfo.phone" readonly>
            </section>
            <!-- <section>
              <label>电子邮箱</label>
              <input type="text" v-model="email" readonly>
            </section> -->
            <!-- <section>
              <label>生日</label>
              <input type="text" v-model="birth">
            </section>
            <section class="height-auto">
              <label>地址</label>
              <textarea ref="textarea" @input="autoHeight" spellcheck="false" v-model="address"></textarea>
            </section> -->
        </main>
        <footer>
            <section>
                <VuiButton type="text" class="btn" @click.native="$store.dispatch('app/quit')">退出登录</VuiButton>
            </section>
        </footer>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'ProfileSettings',
        computed: {
            ...mapState('app', ['userinfo']),
        },
        methods: {
            autoHeight() {
                const el = this.$refs.textarea

                if (el) {
                    el.style.height = '22px'
                    el.style.height = `${el.scrollTop + el.scrollHeight}px`
                }
            },
            handleClick(name) { // 跳转到对应页面更新信息
                if (name === 'userName') {
                    this.$router.push({name, params: {userName: this.userinfo.name}})
                } else if (name === 'officeName') {
                    this.$router.push({
                        name,
                        params: {officeId: this.userinfo.officeId, officeName: this.userinfo.officeName}
                    })
                } else if (name === 'phone') {
                    this.$router.push({name, params: {userName: this.userinfo.phone}})
                } else if (name === 'location') {
                    this.$router.push({name, params: {location: this.userinfo.location}})
                }
            }
        },
        mounted() {
            this.autoHeight()
        },
    }
</script>

<style lang="scss">
    #ProfileSettings {
        min-height: 100vh;
        background-color: #f0f0f0;
        width: 500px;
        margin: 0 auto;

        .btn {
            padding: 0;
            height: auto;
            background-color: transparent;
            font-size: 17px;
            line-height: 24px;
            font-weight: bold;
            color: #ed6c00;
        }

        .height-auto {
            height: auto;
        }

        section {
            padding: 11px 20px 11px 0;
            margin-left: 20px;
            border-bottom: 1px solid #e5e4e4;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:last-child {
                border-bottom: none;
            }
        }

        header {
            padding: 10px 20px;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);

            .title {
                font-size: 17px;
                line-height: 24px;
                font-weight: bold;
            }
        }

        main {
            margin-top: 20px;
            background-color: #ffffff;
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);

            label {
                width: 120px;
                font-size: 16px;
                line-height: 22px;
                color: #000000;
                flex-shrink: 0;
                flex-grow: 0;
            }

            input,
            textarea {
                border: none;
                outline: none;
                margin: 0;
                padding: 0;
                font-size: 16px;
                line-height: 22px;
                letter-spacing: 0.3px;
                text-align: right;
                color: #868688;
                flex-shrink: 1;
                flex-grow: 1;
                background-color: transparent;
                resize: none;
            }
        }

        footer {
            margin-top: 20px;
            background-color: #ffffff;
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        }
    }
</style>
